import {Component, OnInit, Inject} from '@angular/core';
import {v1_breezeServiceName} from '@app/v1_integration';
import {ITermGroup} from '@shared/models';

@Component({
  selector: 'idp2-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor(
    @Inject(v1_breezeServiceName)
    private _breezeService: Pulse.Services.IBreezeService
  ) {}

  ngOnInit() {
    const query = breeze.EntityQuery.from('TermGroup_GetCurrent')
      .noTracking(true)
      .take(1);

    this._breezeService
      .getEntityManager()
      .executeQuery(query)
      .then(data => {
        const tg = <ITermGroup>data.results[0];
        console.log(tg);
      });
  }
}
